import React, {useEffect, useState} from 'react'
import {getOutgoingShippingOrder} from "../../../services/serviceWarehouseOutgoing";
import {Table} from "antd";
import TagsStatus from "../TagsStatus";
import TagsType from "../TagsType";
import OutgoingShippingEdit from "./OutgoingShippingEdit";

const OutgoingShipping = () => {
    const [updateList, setListUpdate] = useState(false)
    const [sortedList, setSortedList] = useState([])
    const [pageNo, setPageNo] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [totalPaginationData, setTotalPaginationData] = useState(0);

    useEffect(() => {
        getOutgoingShippingOrder(pageNo, pageSize)
            .then(({data}) => {
                setTotalPaginationData(data.totalElements);
                handlers.sortData(data)
            })
    }, [updateList, pageNo, pageSize])

    const handlers = {
        updater(){
            setListUpdate(!updateList)
        },
        sortData(list){
            let sorted = []
            if (list.hasOwnProperty('content') && list.content.length) {
                list.content.forEach(item=>{
                    let pushObj = {
                        key: item.id,
                        id: item.id,
                        stockCode: item.sc,
                        shippingUnit: item.u,
                        shippingQuantity: item.oq,
                        shippingCustomer: item.c,
                        shippingStatus: item.os,
                        shippingType: item.ot
                    }
                    sorted.push(pushObj)
                })
                setSortedList(sorted)
            }
        }
    }

    const onPaginationChange = (pageNo, pageSize) => {
        setPageSize(pageSize)
        setPageNo(pageNo - 1)
    }

    const columns = [
        {
            title: 'Ürün',
            dataIndex: 'stockCode',
            key: 'stockCode'
        },
        {
            title: 'Miktar',
            dataIndex: 'shippingQuantity',
            key: 'shippinhQuantity'
        },
        {
            title: 'Birim',
            dataIndex: 'shippingUnit',
            key: 'shippingUnit'
        },
        {
            title: 'Müşteri',
            dataIndex: 'shippingCustomer',
            key: 'shippingCustomer'
        },
        {
            title: 'Çıkış Durumu',
            key: 'shippingStatus',
            render: (text, record) => <TagsStatus record={record.shippingStatus} />
        },
        {
            title: 'Çıkış Tipi',
            key: 'shippingType',
            render: (text, record) => <TagsType record={record.shippingType} />
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <OutgoingShippingEdit record={record} updater={handlers.updater} />
        }
    ]

    return(
        <React.Fragment>
            <Table
                scroll={{x: 'max-content'}}
                columns={columns}
                dataSource={sortedList}
                pagination={{total: totalPaginationData, onChange: onPaginationChange}}
            />
        </React.Fragment>
    )
}
export default OutgoingShipping